import Link from 'next/link'

import Box, { BoxProps } from '@mui/material/Box'
import { styled, useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'

import { Icon } from '@iconify/react'
import { useTranslation } from 'react-i18next'

const FlexBox = styled(Box)<BoxProps>({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
})

const Container = styled(FlexBox)<BoxProps>(({ theme }) => ({
  height: 860,
  maxHeight: '100%',
  paddingTop: theme.spacing(4)
}))

const Content = styled(FlexBox)<BoxProps>(({ theme }) => ({
  width: 500,
  flexDirection: 'column',
  gap: theme.spacing(12)
}))

const TextContent = styled(FlexBox)<BoxProps>(({ theme }) => ({
  flexDirection: 'column',
  textAlign: 'center',
  gap: theme.spacing(6)
}))

type NotFoundComponentProps = {
  entityType?: string
  message?: string
  icon?: string
  iconSize?: number
}

const NotFoundComponent = ({
  entityType,
  message,
  icon = 'tabler:map-search',
  iconSize = 200
}: NotFoundComponentProps) => {
  const theme = useTheme()
  const { t } = useTranslation()

  entityType = entityType ? entityType : t('ENTITY.page')
  message = message ? message : t('NOT_FOUND.page')

  return (
    <Container>
      <Content>
        <Icon fontSize={iconSize} color={theme.palette.text.disabled} icon={icon} />
        <TextContent>
          <Typography variant='h2' sx={{ ':first-letter': { textTransform: 'capitalize' } }}>
            {t('NOT_FOUND.entity', { page: t(`ENTITY.${entityType}`) })}
          </Typography>
          <Typography variant='h5'>{message}</Typography>
        </TextContent>
        <Button href='/' component={Link} variant='contained' startIcon={<Icon icon='tabler:home' />}>
          {t('ACTION.go_home')}
        </Button>
      </Content>
    </Container>
  )
}

export default NotFoundComponent
